import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiUsers, FiBookOpen, FiAward, FiPlayCircle, FiCheckCircle, FiTrendingUp, FiArrowRight } from 'react-icons/fi';
import api from '../../api/client';
import Estrellas from '../../components/Estrellas';

export default function PanelAdmin() {
    const [stats, setStats] = useState({});
    const [topCursos, setTopCursos] = useState([]);
    const [comentarios, setComentarios] = useState([]);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/admin/estadisticas'),
            api.get('/admin/reportes/cursos-top'),
            api.get('/admin/reportes/comentarios')
        ]).then(([s, t, c]) => {
            setStats(s.data.estadisticas || {});
            setTopCursos(t.data.reportes || []);
            setComentarios(c.data.comentarios || []);
        }).finally(() => setCargando(false));
    }, []);

    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;

    return (
        <div>
            <h1 style={{ margin: '0 0 6px', fontSize: 26 }}>Panel de Administracion</h1>
            <p style={{ color: 'var(--texto-suave)', margin: '0 0 24px' }}>Resumen general del sistema</p>

            <div className="stats-grid">
                <div className="stat-card">
                    <div className="label"><FiUsers /> Usuarios</div>
                    <div className="valor">{stats.total_usuarios || 0}</div>
                </div>
                <div className="stat-card">
                    <div className="label"><FiBookOpen /> Cursos</div>
                    <div className="valor">{stats.total_cursos || 0}</div>
                </div>
                <div className="stat-card">
                    <div className="label"><FiUsers /> Profesores</div>
                    <div className="valor">{stats.total_profesores || 0}</div>
                </div>
                <div className="stat-card">
                    <div className="label"><FiPlayCircle /> Visualizaciones</div>
                    <div className="valor">{stats.total_visualizaciones || 0}</div>
                </div>
                <div className="stat-card">
                    <div className="label"><FiAward /> Certificados</div>
                    <div className="valor">{stats.total_certificados || 0}</div>
                </div>
                <div className="stat-card">
                    <div className="label"><FiCheckCircle /> Cursos Completados</div>
                    <div className="valor">{stats.cursos_completados || 0}</div>
                </div>
            </div>

            <div className="card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                    <h3 style={{ margin: 0 }}><FiTrendingUp /> Cursos mejor calificados</h3>
                    <Link to="/admin/reportes" className="btn btn-fantasma">Ver todos <FiArrowRight /></Link>
                </div>
                {topCursos.length === 0 ? (
                    <p style={{ color: 'var(--texto-suave)' }}>Sin datos aun</p>
                ) : (
                    <table className="tabla">
                        <thead>
                            <tr>
                                <th>Curso</th>
                                <th>Profesor</th>
                                <th>Calificacion</th>
                                <th>Inscritos</th>
                                <th>Completados</th>
                            </tr>
                        </thead>
                        <tbody>
                            {topCursos.slice(0, 5).map(c => (
                                <tr key={c.id}>
                                    <td>{c.nombre}</td>
                                    <td>{c.profesor || '-'}</td>
                                    <td>
                                        <Estrellas valor={Math.round(c.calificacion_promedio)} soloLectura tamano={12} />
                                        {' '}{Number(c.calificacion_promedio).toFixed(1)} ({c.total_calificaciones})
                                    </td>
                                    <td>{c.total_inscritos}</td>
                                    <td>{c.completados}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className="card">
                <h3>Comentarios recientes</h3>
                {comentarios.length === 0 ? (
                    <p style={{ color: 'var(--texto-suave)' }}>Sin comentarios aun</p>
                ) : comentarios.slice(0, 8).map(c => (
                    <div key={c.id} className="comentario">
                        <div>
                            <span className="autor">{c.usuario_nombre} {c.apellido_paterno}</span>
                            <span style={{ marginLeft: 8, color: 'var(--acento)' }}>en {c.curso}</span>
                            <span className="fecha">{new Date(c.fecha_creacion).toLocaleDateString('es-MX')}</span>
                        </div>
                        <Estrellas valor={c.estrellas} soloLectura tamano={12} />
                        <div className="texto">{c.comentario}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
